import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = createKubbApiClient('audit-support');

export default axiosClient;
